import {propOr} from 'ramda';
import {CheckoutTotalsType, TotalsResponseV2Type} from '../checkoutType';

/**
 * transition helper between API`s versions.
 * @param {CheckoutTotalsType} data - response from "api/rest/checkout/cart/totals"
 * @return {CheckoutTotalsType} prepared data for the "totals" part of "cart" reducer
 */
export const totalsAdapterV2 = (data: TotalsResponseV2Type): CheckoutTotalsType => {
    const couponsData: string = propOr(
        '',
        'title',
        data.totals.find(item => item && item.code === 'discount'),
    );
    const shippingMethod: string = propOr(
        '',
        'title',
        data.totals.find(item => item && item.code === 'shipping'),
    );
    const appliedCoupons = (couponsData.match(/\((.+)\)/) || [])[1];

    return {
        ...data,
        appliedCoupons: appliedCoupons ? [...appliedCoupons.split(', ')] : [],
        count: data.items.length,
        shippingMethod,
        shippingPrice: String(data.shipping.price),
        shippingTitle: data.shipping.title,
        shippingPriceInclTax: data.shipping.priceInclTax,
        shippingTax: data.shipping.shippingTax,
        shippingTaxRate: data.shipping.shippingTaxRate,
        shippingDiscount: data.shipping.discount,
        subTotal: String(data.subtotal),
        subtotal: String(data.subtotal),
        total: String(data.grandTotal),
        totalFinalPrice: data.totalFinalPrice,
        discount: String(data.discount.price),
        taxTotal: data.totalTax,
        copay: String(data.copay),
        items: data.items.map(item => ({
            ...item,
            id: String(item.id),
            price: String(item.price),
            name: String(item.name),
        })),
    };
};
